var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78844 0H1.38847C0.726055 0 0.188477 0.512001 0.188477 1.14285V14.8571C0.188477 15.488 0.726076 16 1.38847 16H3.78847C4.45147 16 4.98848 15.4886 4.98848 14.8571V1.14285C4.98846 0.512001 4.45145 0 3.78844 0ZM10.9884 0H8.58847C7.92546 0 7.38846 0.512001 7.38846 1.14285V14.8571C7.38846 15.488 7.92546 16 8.58847 16H10.9885C11.6515 16 12.1885 15.4886 12.1885 14.8571V1.14285C12.1885 0.512001 11.6515 0 10.9884 0Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.6335b04554c0f2f0ba9793f787c40df8.svg";
export { ForwardRef as ReactComponent };